import React from 'react'
import BaseForm from './base-form.component'
import StyledStepFrom from './styled-step-from.component'
import MuvicardForm from './muvicard-form.component'

export default class StepSixMuvicardForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<MuvicardForm
					initialValues={this.props.initialValues}
					ref={'form'}
				/>
			</StyledStepFrom>
		)
	}
}
